import { FC, useCallback, useContext, useEffect, useState } from "react";
import { Context } from "../../../context";
import { Lookup } from "src/common/Common.Type";
import { IDropDownSearch } from "./SeacrhToolTypes/DropDownS.type";
import { dropdownValue } from "src/component/asyncDropdown/AsyncDropDown.types";
import { useDropdownApi } from "src/hooks/useDropdownApi";
import DropDownField from "src/component/DropDownField";


const DropDownSearch: FC<IDropDownSearch> = ({ ApiMethod, depArr, selectFirst, sourceId, isMulti, accessor, Header, probName, className, optionList }) => {
    const [selectedOption, setSelectedOption] = useState<dropdownValue>({
        value: isMulti ? [] : null,
        errorMsg: "",
        isRequired: false
    });
    const { setCustomSearchData, customSearchData, clearField, ToggleReloadTable } = useContext(Context);

    const { isPending, options } = useDropdownApi({ ApiMethod, sourceId, depArr, optionList })

    const handleChange = useCallback((option: dropdownValue) => {
        const searchObjectValues: any = { ...customSearchData };
        const fieldName = `${probName || accessor}${isMulti ? "s" : ""}`;
        if (!isMulti) {
            //@ts-ignore
            searchObjectValues[fieldName] = option?.value?.value ?? option?.value ?? "";
        } else {
            searchObjectValues[fieldName] =
                Array.isArray(option.value) ? option?.value.map((option: Lookup) => option?.value) : [];
        }
        setSelectedOption(option);
        setCustomSearchData((prev: any) => ({ ...prev, ...searchObjectValues }));
    }, [customSearchData, probName, accessor, isMulti, setCustomSearchData]);

    useEffect(() => {
        setSelectedOption({ value: isMulti ? [] : null, errorMsg: "", isRequired: false })
    }, [clearField, isMulti])



    useEffect(() => {
        if (options?.length && selectFirst) {
            //@ts-ignore
            handleChange({ value: options[0] })
            ToggleReloadTable((prev: boolean) => !prev);
        }
    }, [options, selectFirst])


    return (
        <DropDownField
            value={selectedOption}
            setValue={handleChange}
            options={options}
            label={Header}
            isMulti={isMulti}
            disabled={isPending}
            placeholder={Header}
            className={className}
            isClearable={!selectFirst}
            isRequired={false}
        />
    );
};

export default DropDownSearch;
